/**
 * Media Content block: styles + background video (YouTube, Vimeo, HTML5).
 */
import './style.scss';

document.addEventListener('DOMContentLoaded', initMediaContentVideos);

function initMediaContentVideos() {
	document.querySelectorAll('.media-content__video--bg').forEach((el) => {
		const type = el.getAttribute('data-video-type');
		const id = el.getAttribute('data-video-id');
		const mp4 = el.getAttribute('data-mp4');
		const webm = el.getAttribute('data-webm');
		if (type === 'youtube' && id) initYouTubeBg(el, id);
		else if (type === 'vimeo' && id) initVimeoBg(el, id);
		else if (type === 'html5' && (mp4 || webm)) initHtml5Bg(el, mp4, webm);
	});
}

function initYouTubeBg(container, videoId) {
	container.style.opacity = '0';
	const params = new URLSearchParams({
		autoplay: '1',
		mute: '1',
		loop: '1',
		playlist: videoId,
		controls: '0',
		rel: '0',
	});
	const iframe = document.createElement('iframe');
	iframe.src = `https://www.youtube.com/embed/${videoId}?${params}`;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute(
		'allow',
		'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
	);
	iframe.setAttribute('allowfullscreen', '');
	iframe.className = 'media-content__video-iframe';
	iframe.onload = () => {
		container.style.opacity = '1';
	};
	container.appendChild(iframe);
	setTimeout(() => {
		container.style.opacity = '1';
	}, 2000);
}

function initVimeoBg(container, videoId) {
	container.style.opacity = '0';
	const params = new URLSearchParams({
		background: 1,
		autoplay: 1,
		muted: 1,
		loop: 1,
	});
	const iframe = document.createElement('iframe');
	iframe.src = `https://player.vimeo.com/video/${videoId}?${params}`;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('allow', 'autoplay; fullscreen');
	iframe.setAttribute('allowfullscreen', '');
	iframe.className = 'media-content__video-iframe';
	iframe.onload = () => {
		container.style.opacity = '1';
	};
	container.appendChild(iframe);
	setTimeout(() => {
		container.style.opacity = '1';
	}, 2000);
}

function initHtml5Bg(container, mp4, webm) {
	container.style.opacity = '0';
	const poster = container.getAttribute('data-poster');
	const video = document.createElement('video');
	video.setAttribute('playsinline', '');
	video.setAttribute('muted', '');
	video.setAttribute('autoplay', '');
	video.setAttribute('loop', '');
	if (poster) video.setAttribute('poster', poster);
	video.className = 'media-content__video-html5';
	if (webm) {
		const s = document.createElement('source');
		s.src = webm;
		s.type = 'video/webm';
		video.appendChild(s);
	}
	if (mp4) {
		const s = document.createElement('source');
		s.src = mp4;
		s.type = 'video/mp4';
		video.appendChild(s);
	}
	video.addEventListener(
		'canplay',
		() => {
			container.style.opacity = '1';
		},
		{ once: true }
	);
	container.appendChild(video);
	video.play().catch(() => {});
}
